import { CommunityApp } from '@atlassian/learning-components';
import { sendTrackEvent } from '../services/analytics';
import { getAnalyticsAnonymousId } from './utilities';

export const sendNewAccountEvent = async (isNewForumsProfile: boolean, userAccountId?: string) => {
  try {
    const articlePopupLoginClicked = window.sessionStorage.getItem('article_popup_login_clicked');
    const allVisitedContentPages = JSON.parse(window.sessionStorage.getItem('targeted_messaging2_all_visited_content_pages') || "[]");
    let attributes = {};
    let name = '';
    let action = 'signup';
    if (articlePopupLoginClicked) {
      name = 'articlePopup';
      action = 'signup';
      attributes = {
        isNewForumsProfile,
        anonymousId: getAnalyticsAnonymousId(),
        variant: articlePopupLoginClicked,
        totalVisitCount: allVisitedContentPages.length,
      };
      window.sessionStorage.removeItem('article_popup_login_clicked');
    }

    const targetedMessaging2LoginClicked = window.sessionStorage.getItem('targeted_messaging2_login_clicked');
    if (targetedMessaging2LoginClicked) {
      const expSessionId = window.sessionStorage.getItem('targeted_messaging2_session_id') || 'na';
      action = 'signup';
      name = 'targetedMessaging2';
      attributes = {
        isNewForumsProfile,
        anonymousId: getAnalyticsAnonymousId(),
        expSessionId: JSON.parse(expSessionId),
        totalVisitCount: allVisitedContentPages.length,
        experimentName: 'community-forums-exp2-2nd-visit-popup'
      };
      window.sessionStorage.removeItem('targeted_messaging2_login_clicked');
    }

    const anonymousKudosKey = 'community-forums-anonymous-kudos__login_clicked';
    const variantName = window.sessionStorage.getItem(anonymousKudosKey);
    if(variantName?.length) {
      name = 'authentication';
      action = 'loggedIn';
      attributes = {
        isNewForumsProfile,
        anonymousId: getAnalyticsAnonymousId(),
        variantName,
        experiment: 'community-forums-anonymous-kudos'
      };
      window.sessionStorage.removeItem(anonymousKudosKey);
    }
    await sendTrackEvent(
        CommunityApp.HOME,
        name,
        action,
        attributes,
        userAccountId,
      );
  } catch (error) {
    console.error('[sendNewAccountEvent] Error sending event:', error);
  }
};
